import React, { FC } from 'react';
import Image from '../Image';
import { useStyles } from './styles';

export interface BannerProps {
  banner?: string;
  limitType?: 'min' | 'max';
  limitSize?: number;
}

const Banner: FC<BannerProps> = ({ banner, limitType, limitSize }) => {
  const styles = useStyles([limitType, limitSize]);

  return (
    <div className={styles.banner} aria-label="banner">
      {banner && <Image className={styles.image} src={banner} />}
    </div>
  );
};

export default Banner;
